import { styled, type SxProps, type Theme } from "@mui/material/styles";

export const TAB_SX: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 2.5, maxWidth: 896 };

export const SECTION_SX: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 0.75 };

export const ROWS_SX: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 1.25 };

export const COLOR_ROW_SX: SxProps<Theme> = { display: "flex", alignItems: "flex-start", gap: 2.5 };

export const FIELD_SX: SxProps<Theme> = { width: 224, flexShrink: 0 };

export const SHADES_SX: SxProps<Theme> = { display: "flex", flex: 1, minWidth: 0, gap: 1.5 };

export const SHADE_SX: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minWidth: 0,
  gap: 0.75,
};

/** Shade boxes match the 40px input row beside them; an empty one shows the page background. */
export const ShadeSwatch = styled("span", {
  shouldForwardProp: (prop) => prop !== "swatchColor",
})<{ swatchColor?: string }>(({ theme, swatchColor }) => ({
  position: "relative",
  height: 40,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 6,
  backgroundColor: swatchColor ?? theme.palette.background.default,
}));

/** Figma's 8px dot with its 2px halo, in the swatch's top-right corner. */
export const ShadeIndicator = styled("span")({ position: "absolute", top: 7, right: 7, display: "flex" });
